import React from 'react'

import { Portlet, Button } from '_zari/core'

import * as InventarioService from 'services/inventario.service'

import * as Modals from './modals'

const portletBreadcrumbs = [{ name: 'Consumos' }]

const InformeConsumos = ({ sectionData }) => {
  const [productos, setProductos] = React.useState([])
  const [centrosCosto, setCentrosCosto] = React.useState([])
  const [centrosCostoDetallesObtenidos, setCentrosCostoDetallesObtenidos] = React.useState([])
  const [mostrarDetallesModal, setMostrarDetallesModal] = React.useState(false)
  const [modalData, setModalData] = React.useState([])
  const [filtros, setFiltros] = React.useState({})

  React.useEffect(() => {
    const { productos, centrosCosto, centrosCostoDetalles, ...filtros } = sectionData
    setFiltros(filtros)
    setCentrosCostoDetallesObtenidos(centrosCostoDetalles)
    setProductos(productos)
    setCentrosCosto(centrosCosto)
  }, [sectionData, centrosCostoDetallesObtenidos])

  const mostrarDetalle = React.useCallback(
    async idProducto => {
      await InventarioService.obtenerDetallexIdProductoAsConsultaModalTable({ ...filtros, idProducto }).then(({ data }) => {
        setModalData(data)
        setMostrarDetallesModal(true)
      })
    },
    [filtros]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header title='Consulta Consumos' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <table border='1' width='100%' className='text-center'>
            <thead>
              <tr>
                <th>CODIGO</th>
                <th>DESCRIPCION</th>
                <th>COSTO</th>
                <th colSpan={2}>TOTAL</th>
                {centrosCosto.map(x => (
                  <th colSpan={2}>{`${x.codigo} (${x.descripcion})`}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {productos.map(x => (
                <tr>
                  <td>{x.codigo}</td>
                  <td>{x.descripcion}</td>
                  <td>{x.costoProducto}</td>
                  <td>
                    <span className='mr-5'>{x.suma}</span>
                    {x.suma > 0 && (
                      <Button disabled={mostrarDetallesModal} onClick={() => mostrarDetalle(x.id)}>
                        Detalle
                      </Button>
                    )}
                  </td>
                  <td>{x.sumaImporte}</td>
                  {centrosCosto.map(y =>
                    centrosCostoDetallesObtenidos.map(
                      z =>
                        z.idProducto === x.id &&
                        z.id === y._id && (
                          <>
                            <td>{z.total}</td> <td>{z.importe}</td>{' '}
                          </>
                        )
                    )
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </Portlet.Body>
      </Portlet>
      {mostrarDetallesModal && (
        <Modals.TablaDetallesModal handleClose={() => setMostrarDetallesModal(false)} show={mostrarDetallesModal} modalData={modalData} />
      )}
    </>
  )
}

export default React.memo(InformeConsumos)
